import React from "react";

import AddIcon from "icons/AddIcon";
import DeleteIcon from "icons/DeleteIcon";
import { Meet, RefDetails } from "types";
import {
  updateAttributeOnDocument,
  updateAttributesOnDocument,
} from "util/pouchActions";
import { generateId } from "util/docHelper";

const deleteRef = (meet: Meet, ref: RefDetails) => {
  const existingRefs = meet.restricted.refs;

  const updatedRefs = { ...existingRefs };
  delete updatedRefs[ref.id];

  console.log("updatedRefs", updatedRefs);

  updateAttributeOnDocument(meet._id, meet.restricted._id, "refs", updatedRefs);
};

const addRef = (meet: Meet) => {
  const newRef: RefDetails = {
    id: generateId(""),
    name: "",
    birthDate: "",
    state: "",
    memberId: "",
    chief: false,
    side: false,
    weighIn: false,
    doping: false,
    technicalSecretary: false,
    technicalController: false,
    jury: false,
    scoring: false,
    equipmentCheck: false,
    meetDirector: false,
  };

  const existingRefs = meet.restricted.refs;

  updateAttributesOnDocument(meet._id, meet.restricted._id, {
    refs: { ...existingRefs, [newRef.id]: newRef },
  });
};

const ButtonCell = ({
  data,
  meet,
  style,
}: {
  data: any;
  meet: Meet;
  style: React.CSSProperties;
}) => {
  const ref = data;
  if (ref.row === "header") {
    return (
      <div style={style} className="table-cell-inner button-cell">
        <button onClick={() => addRef(meet)} aria-label="Add Lifter">
          <AddIcon />
        </button>
      </div>
    );
  } else {
    return (
      <div style={style} className="table-cell-inner button-cell">
        <button
          onClick={() => deleteRef(meet, ref)}
          aria-label={`Delete ${ref.name || "Ref"}`}
        >
          <DeleteIcon />
        </button>
      </div>
    );
  }
};

export default ButtonCell;
